import { apiGet, apiPost, apiDelete, apiPut } from 'api';
import { RecordingType, StationProgramScheduleType } from 'types';
// import * from 'types';

const broadcast = {
  get: async (id: number) => {
    const data = await apiGet(`${process.env.REACT_APP_API_URI}/api/broadcast/get/${id}`);
    return data;
  },
  getLanguages: async () => {
    const data = await apiGet(`${process.env.REACT_APP_API_URI}/api/broadcast/language/all`);
    return data;
  },
  getStationsAll: async () => {
    const data = await apiGet(`${process.env.REACT_APP_API_URI}/api/broadcast/station/all`);
    return data;
  },
  getSchedule: async (id: number) => {
    const data = await apiGet(`${process.env.REACT_APP_API_URI}/api/broadcast/station/${id}/schedule`);
    return data;
  },
  getRecordings: async (schedule: any) => {
    // console.log(schedule);
    const data = await apiPost(`${process.env.REACT_APP_API_URI}/api/broadcast/recording/schedule`, schedule);
    return data;
  },
  postRecordingSplit: async (recordingIds : number[]) => {
    var body = recordingIds;
    const data = await apiPost(`${process.env.REACT_APP_API_URI}/api/broadcast/recording/split`, body);
    return data;
  }
};

export default broadcast;
